import React, { Fragment, useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import moment from "moment";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useTranslation } from "react-i18next";
import { mockRankTimeRecord } from "../../../utils/mockData";
import { Box, Typography } from "@mui/material";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import CardCheckIn from "./components/CardCheckIn";
import CustomerCard from "./components/CustomerCard";
import { icons } from "../../../assets/icons/icons";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import { RemoveRedEyeOutlined } from "@mui/icons-material";
import ModalRecordTime from "./components/ModalRecordTime";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { workScheduleApi } from "../../../api/work-schedule/work-schedule.api";
import { alertError } from "../../../components/alert/swal";
import { RootState } from "../../../store/store";
import { checkPermission } from "../../../utils/app.utils";

type Props = {};

const TimeRecordSystem: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const profileReducer = useSelector((state: RootState) => state.profile.profile);
  const permission: any[] = profileReducer?.permission || [];
  const checkPermit = checkPermission('TimeRecordSystem', permission);

  const [dataTimeRecord, setDataTimeRecord] = useState<any>([]);
  const [dataRankingTimeRecord, setDataRankingTimeRecord] = useState<any>([]);
  const [dataTimeRecordDetail, setDataTimeRecordDetail] = useState<any>({
    id_work_schedule: 0,
    date: "",
    check_in: "",
    check_out: "",
    number_of_hours: "",
    latitude_in: 0,
    longitude_in: 0,
    latitude_out: 0,
    longitude_out: 0,
    detail_in: "",
    detail_out: "",
    file_path_in: "",
    file_path_out: "",
  });

  const [currentItem, setCurrentItem] = useState(null);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>();
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const [isModalRecordTimeCheckIn, setIsModalRecordTimeCheckIn] =
    useState<boolean>(false);
  const [isModalRecordTimeCheckOut, setIsModalRecordTimeCheckOut] =
    useState<boolean>(false);
  const [isModalRecordTimeHistory, setIsModalRecordTimeHistory] =
    useState<boolean>(false);

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setStartDate(moment(value[0]).format("YYYY-MM-DD"));
    setEndDate(moment(value[1]).format("YYYY-MM-DD"));
  };

  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const headCells = [
    {
      id: "#",
      width: 2,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "date",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("วัน/เดือน/ปี"),
    },
    {
      id: "check_in",
      disablePadding: false,
      width: 75,
      sortable: false,
      align: "center",
      label: t("เวลาเข้างาน"),
    },
    {
      id: "check_out",
      disablePadding: false,
      align: "center",
      width: 25,
      label: t("เวลาออกงาน"),
    },
    {
      id: "hour",
      disablePadding: false,
      align: "center",
      width: 40,
      label: t("จำนวนชั่วโมง"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_work_schedule,
      date,
      check_in,
      check_out,
      number_of_hours,
      latitude_in,
      longitude_in,
      latitude_out,
      longitude_out,
      detail_in,
      detail_out,
      file_path_in,
      file_path_out,
    } = objData;

    const objRenderData = {
      key: id_work_schedule,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: date ? moment(date).format("DD/MM/YYYY") : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: check_in || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: check_out || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: number_of_hours,
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              {checkPermit.isView && (
                <RemoveRedEyeOutlined
                  onClick={() => {
                    setIsModalRecordTimeHistory(true);
                    setDataTimeRecordDetail({
                      id_work_schedule: id_work_schedule,
                      date: date,
                      check_in: check_in,
                      check_out: check_out,
                      number_of_hours: number_of_hours,
                      latitude_in: latitude_in ?? 0,
                      longitude_in: longitude_in ?? 0,
                      latitude_out: latitude_out ?? 0,
                      longitude_out: longitude_out ?? 0,
                      detail_in: detail_in,
                      detail_out: detail_out,
                      file_path_in: file_path_in,
                      file_path_out: file_path_out,
                    });
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                />
              )}
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  // const handleChangeValueSearch = (name: string, value: any) => {
  //   setInputValueSearch((prev: any) => {
  //     return {
  //       ...prev,
  //       [name]: value,
  //     };
  //   });
  // };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  // Define rank and employee data
  const rankArray = [
    { rank: 1, rank_name: t("อันดับ 1"), color: "#FCAF17" },
    { rank: 2, rank_name: t("อันดับ 2"), color: "#828282" },
    { rank: 3, rank_name: t("อันดับ 3"), color: "#E37F22" },
    { rank: 4, rank_name: t("อันดับ 4"), color: "#4A4A4A" },
  ];

  const getTimeRecord = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      sdate: startDate,
      edate: endDate,
    };
    const res = await workScheduleApi.getMyTimeRecord(query);
    const data = res.data;
    if (data.status < 300 && data.data) {
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
      setDataTimeRecord(data.data.items);
    } else {
      setDataTimeRecord([]);
    }
  };

  const fetchGetRankingTimeRecord = async () => {
    const param = {
      limit: 20,
    };
    const res = await workScheduleApi.getRankEmployee(param);
    const data = res.data;
    if (data.status < 300 && data.data && data.data?.items.length > 0) {
      setDataRankingTimeRecord(data.data.items);
    } else {
      setDataRankingTimeRecord([]);
    }
  };

  useEffect(() => {
    fetchGetRankingTimeRecord();
  }, []);

  useEffect(() => {
    getTimeRecord();
  }, [page, pageLimit, sortBy, sortType, startDate, endDate]);

  const handleClick = () => {
    const currentDate = new Date().toLocaleDateString("en-CA");

    // Find the item that matches the current date
    const item = dataTimeRecord.find((d: any) => d.date === currentDate);

    if (item) {
      setCurrentItem(item);
      if (!item.check_in) {
        setIsModalRecordTimeCheckIn(true);
      } else if (item.check_in && !item.check_out) {
        setIsModalRecordTimeCheckOut(true);
      } else {
        alertError(t("วันนี้ได้มีการบันทึก ประวัติการเข้า-ออกงาน แล้ว"));
      }
    } else {
      setCurrentItem(null); // Or handle as needed if no current item
      setIsModalRecordTimeCheckIn(true);
    }
  };

  return (
    <div>
      <ModalRecordTime
        setIsOpenModal={(isOpen: boolean) =>
          setIsModalRecordTimeCheckIn(isOpen)
        }
        isOpenModal={isModalRecordTimeCheckIn}
        actionType="check_in"
        onFetch={() => {
          getTimeRecord();
        }}
      />

      <ModalRecordTime
        setIsOpenModal={(isOpen: boolean) =>
          setIsModalRecordTimeCheckOut(isOpen)
        }
        isOpenModal={isModalRecordTimeCheckOut}
        actionType="check_out"
        onFetch={() => {
          getTimeRecord();
        }}
      />

      <ModalRecordTime
        setIsOpenModal={(isOpen: boolean) =>
          setIsModalRecordTimeHistory(isOpen)
        }
        isOpenModal={isModalRecordTimeHistory}
        actionType="history"
        onFetch={() => {
          getTimeRecord();
        }}
        data={dataTimeRecordDetail}
      />

      <Box mb={4}>
        <ContentHeading
          title={t("ระบบบันทึกเวลาปฏิบัติงาน")}
          detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
        />
      </Box>

      <section className="my-4">
        <Box
          sx={{
            display: "flex",
            gap: 2, // Adjust spacing between cards
            width: "100%",
            overflowX: "auto",
            paddingBottom: 4,
          }}
        >
          <CardCheckIn onClick={handleClick} />
          {dataRankingTimeRecord
            .slice(0, 4)
            .map((employee: any, index: number) => {
              const rank = rankArray[employee.rank - 1];
              return (
                <CustomerCard
                  key={index + 1}
                  headerColor={rank.color}
                  headerText={rank.rank_name}
                  rank={employee?.rank}
                  position_name={employee?.position_name || ""}
                  department_name={employee?.department_name_th || employee?.department_name_eng || ""}
                  imageUrl={
                    employee.file_path
                      ? process.env.REACT_APP_FILE_BASE_API +
                      "/" +
                      employee.file_path
                      : icons.profile
                  }
                  customerName={
                    employee.title +
                    " " +
                    employee.first_name +
                    " " +
                    employee.last_name
                  }
                  position={employee.position ?? ""}
                  department={employee.department ?? ""}
                />
              );
            })}
        </Box>
      </section>

      <section
        className="my-4"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <ButtonPrimary
          onClick={() => {
            navigate(routeName.cms.TimeRecordSystemAll);
          }}
          buttonName={t("ดูทั้งหมด")}
          mode="next"
        />
      </section>

      <section className="my-4"></section>

      <section className="my-4">
        <Typography variant="h3">{t("ประวัติการเข้า-ออกงานของท่าน")}</Typography>
      </section>

      <div
        className="w-full mt-[40px]"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", gap: "16px" }}>
          <InputNewRangePicker
            value={selectedDateRange}
            onchange={handleRangeDate}
            onClear={handleClearRangeDate}
            allowClear
          />
        </div>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataTimeRecord &&
            dataTimeRecord.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default TimeRecordSystem;
